@use '@/styles/tokens' as *;

.tooltip {
  max-width: 344px;

  :global(.ant-tooltip-inner) {
    min-height: 0;
    padding: $space-1 $space-2;
    border-radius: 12px;
    box-shadow: var(--shadow-overlay);
    font-size: $font-size-xs;
    line-height: $line-height-base;
  }
}

.light {
  --antd-arrow-background-color: #{$color-neutral-50};

  :global(.ant-tooltip-inner) {
    background: $color-neutral-50;
    color: $color-neutral-950;
  }
}

.dark {
  --antd-arrow-background-color: #{$color-neutral-950};

  :global(.ant-tooltip-inner) {
    background: $color-neutral-950;
    color: $color-neutral-50;
  }
}
